export enum MilestonesSectionConfigurations {
  DISABLED = "DISABLED",
  READ_ONLY = "READ_ONLY",
  EDITABLE = "EDITABLE",
}
